var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("forum-article-block", {
        attrs: {
          hideFooter: _vm.viewRestricted,
          showImage: "",
          disableClick: "",
          showAnswerBtn: "",
          showFullWhoInDescription: ""
        }
      }),
      _vm._v(" "),
      _vm.$store.state.forum.showMainAnswerBlock
        ? _c(
            "div",
            [
              _c("vue-editor", {
                staticClass: "wysiwygStyle wysiwygReduced",
                attrs: { useCustomImageHandler: "" },
                on: { "image-added": _vm.handleImageAdded },
                model: {
                  value: _vm.$store.state.forum.wysiwygEntryAnswer,
                  callback: function($$v) {
                    _vm.$set(_vm.$store.state.forum, "wysiwygEntryAnswer", $$v)
                  },
                  expression: "$store.state.forum.wysiwygEntryAnswer"
                }
              }),
              _vm._v(" "),
              _c(
                "base-button",
                {
                  staticClass: "reply-entry-btn",
                  staticStyle: { margin: "1rem !important" },
                  on: { click: _vm.sendMessage }
                },
                [_vm._v(_vm._s(_vm.$t("send")))]
              ),
              _vm._v(" "),
              _c(
                "base-button",
                {
                  staticStyle: { margin: "1rem !important" },
                  attrs: { gray: "", outline: "" },
                  on: { click: _vm.goBack }
                },
                [_vm._v(_vm._s(_vm.$t("cancel")))]
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.viewRestricted
        ? _c("div", { staticClass: "verticalCenter" }, [
            _c(
              "div",
              {
                staticClass: "forumArticle",
                staticStyle: { "margin-bottom": "2%" }
              },
              [
                _c(
                  "p",
                  { staticStyle: { margin: "1.5rem" } },
                  [
                    _vm._v(_vm._s(_vm.$t("loginFromArticle")) + "\n        "),
                    _c(
                      "base-button",
                      {
                        staticClass: "btn btn-primary fixed-padding-btn-forum",
                        on: {
                          click: function($event) {
                            return _vm.logIn("quienseapunta/" + _vm.entryId)
                          }
                        }
                      },
                      [
                        _c("span", [_vm._v(_vm._s(_vm.$t("accessBtn")))]),
                        _vm._v(" "),
                        _c("base-icon", {
                          attrs: {
                            src:
                              "/static-appopensalud/img/icons/morillas-svg-icons/primary/arrow.svg",
                            color: "white"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            )
          ])
        : _c("forum-message-block", {
            attrs: {
              numPrincipalReplies: _vm.numReplies,
              entryReferenceId: _vm.entryId
            }
          })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-08b6bfa6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-08b6bfa6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/healthy-community/forum/ForumThread.vue
// module id = 4308
// module chunks = 26